@let form = trainingForm();
<div class="selects">
  @let sportError = form?.get('sport')?.invalid && form?.get('sport')?.touched;
  <app-select-field
    [label]="'common.sport_placeholder' | translate"
    [filled]="!!sport()"
    [errorMessage]="sportError ? ('common.required_field' | translate) : undefined"
  >
    <kin-select
      name="coaching-sport"
      id="coaching-sport-select"
      [required]="true"
      [default]="'common.sport_placeholder' | translate"
      [value]="sport()"
      (onSelectedValue)="changeSport($event)"
      [class.error]="sportError"
    >
      @for (sportType of sportTypes; track sportType) {
        <option [value]="sportType">
          {{ 'common.sport.verb.' + sportType | translate | upperFirstLetter }}
        </option>
      }
    </kin-select>
  </app-select-field>

  @for (currentSport of [sport()]; track currentSport) {
    @let workoutModeError = form?.get('workoutMode')?.invalid && form?.get('workoutMode')?.touched;
    <app-select-field
      [label]="'training_block.training_type_label' | translate"
      [filled]="!!workoutMode()"
      [errorMessage]="workoutModeError ? ('common.required_field' | translate) : undefined"
    >
      <kin-select
        [disabled]="!workoutModes()"
        name="coaching-training-type"
        id="coaching-training-type-select"
        [required]="true"
        [default]="'training_block.training_type_placeholder' | translate"
        [value]="workoutMode()"
        [class.error]="workoutModeError"
      >
        @for (workoutModeOption of workoutModes(); track workoutModeOption) {
          <option [value]="workoutModeOption">
            {{ 'common.training_type.' + workoutModeOption | translate | upperFirstLetter }}
          </option>
        }
      </kin-select>
    </app-select-field>
  }
</div>

@let sectionsControl = form?.get('sections');
@let sectionsTooShort = sectionsControl?.errors?.['sectionsTooShort'];
@let sectionsTooLong = sectionsControl?.errors?.['sectionsTooLong'];
@let sectionsRequired = sectionsControl?.hasError('required') && sectionsControl?.touched;
@let sectionsError =
  sectionsRequired
    ? ('training_block.sections_required' | translate)
    : sectionsTooShort
      ? ('coaching_intervals_editor.too_short'
        | translate: { duration: formatTime(sectionsTooShort.missing) })
      : sectionsTooLong
        ? ('coaching_intervals_editor.too_long'
          | translate: { duration: formatTime(sectionsTooLong.excess) })
        : undefined;
<app-sections-editor
  [errorMessage]="sectionsError"
  contentType="coaching"
  [disabled]="disabledEditor()"
  [workoutMode]="workoutMode()"
  [(sections)]="sections"
  [(selectedSectionsIds)]="selectedSectionsIds"
>
  <app-video-uploader
    chartAside
    [mediaForm]="mediaBlockService.mediaForm!"
    [contentType]="mediaBlockService.contentType!"
  />
  <header chartHeader class="workout-header">
    <h3>
      <kin-icon name="workout_stroke" [size]="20" />
      {{ 'training_block.workout_title' | translate }}
    </h3>
  </header>
</app-sections-editor>
